( function ( $, root, undefined ) {
	$( function () {
		'use strict'; // DOM ready, take it away

		// smooth scrolling anchors
		function filterPath( string ) {
			return string
				.replace( /^\//, '' )
				.replace( /(index|default).[a-zA-Z]{3,4}$/, '' )
				.replace( /\/$/, '' );
		}

		var locationPath = filterPath( location.pathname );
		var scrollElem = scrollableElement( 'html', 'body' );
		$( 'a[href^="#"]' ).each( function () {
			var thisPath = filterPath( this.pathname ) || locationPath;
			if (
				locationPath == thisPath &&
				( location.hostname == this.hostname || ! this.hostname ) &&
				this.hash.replace( /#/, '' )
			) {
				var $target = $( this.hash ),
					target = this.hash;
				if ( target ) {
					var targetOffset = $target.offset();
					$( this ).click( function ( event ) {
						event.preventDefault();
						$( scrollElem ).animate(
							{
								scrollTop: targetOffset.top,
							},
							400,
							function () {
								location.hash = target;
							}
						);
					} );
				}
			}
		} );
		// use the first element that is "scrollable"
		function scrollableElement( els ) {
			for (
				var i = 0, argLength = arguments.length;
				i < argLength;
				i++
			) {
				var el = arguments[ i ],
					$scrollElement = $( el );
				if ( $scrollElement.scrollTop() > 0 ) {
					return el;
				} else {
					$scrollElement.scrollTop( 1 );
					var isScrollable = $scrollElement.scrollTop() > 0;
					$scrollElement.scrollTop( 0 );
					if ( isScrollable ) {
						return el;
					}
				}
			}
			return [];
		}

		// // Responsive Menu
		// $('.mobile_toggle').click(function(event) {
		// 	$(this).toggleClass('active');
		// 	$('.nav').toggleClass('active');
		// 	$('.sub-menu').slideUp('fast');
		// 	$('.menu-item-has-children').removeClass('open');
		// 	// $('.blackout').toggleClass('active');
		// });

		//header height
		function setHeaderHeight() {
			var headerHeight = $( '.header' ).outerHeight( true );
			//set spacer same height as header
			$( '.spacer' ).css( 'padding-bottom', headerHeight + 'px' );
		}

		setHeaderHeight();

		$( window ).resize( function ( event ) {
			setHeaderHeight();
		} );

		$( '.forminator-custom-form-405 .forminator-button-submit' ).html(
			'<i class="fal fa-long-arrow-right"></i>'
		);

		$( '#forminator-module-265 .forminator-button-submit' ).addClass(
			'btn'
		);

		$( window ).on( 'forminator:form:submit:success', function ( event ) {
			const form = event.target;

			if ( form && form.id === 'forminator-module-265' ) {
				$( '.contact-intro__terms' ).hide();
			}
		} );

		if ( $( '.testimonial-slider' ).length > 0 ) {
			const splide = new Splide( '.testimonial-slider', {
				type: 'loop',
				drag: 'free',
				focus: 'center',
				autoWidth: true,
				perPage: 3,
				pagination: false,
				arrows: false,
				gap: 60,
				autoScroll: {
					speed: 0.8,
				},
				breakpoints: {
					1200: {
						gap: 40,
					},
					800: {
						gap: 30,
					},
				},
			} );

			splide.mount( window.splide.Extensions );
		}

		if ( $( '.team-slider' ).length > 0 ) {
			const teamSplide = new Splide( '.team-slider', {
				type: 'loop',
				drag: 'free',
				snap: true,
				autoWidth: true,
				rewind: true,
				// perPage: 2,
				// pagination: false,
				arrows: false,
				gap: 20,
			} );

			teamSplide.mount();
		}
	} );
} )( jQuery, this );
